
















import { Component, Emit, Model, Prop, Vue } from "vue-property-decorator";

@Component
export default class CustomSelect extends Vue {
  @Prop({ type: [Object, Array], default: () => ({}) }) optionData!: any;
  @Prop({ type: Object, default: () => ({}) })
  options!: any;
  @Prop({ type: Boolean, default: true }) clearable: boolean;
  @Prop({ type: Boolean, default: false }) disabled: boolean;
  @Prop({ type: Boolean, default: false }) number: boolean;

  @Model("change") bindValue!: any;

  transition(val) {
    return this.number ? Number(val) : val;
  }

  get listData() {
    const { label, value } = this.options;
    if (Array.isArray(this.optionData)) {
      return this.optionData.map(item => ({
        label: item[label || "label"],
        value: this.transition(item[value || "value"])
      }));
    } else {
      return Object.keys(this.optionData).map(key => ({
        [label || "label"]: this.optionData[key],
        [value || "value"]: this.transition(key)
      }));
    }
  }
}
